// src/Navbar.js
import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import "./manufacturing.css";
import Footer from "../components/Footer";
import { useEffect } from "react";
import Button from "react-bootstrap/Button";

import Icon1 from "../assets/Industry/Boxes.png"
import Icon2 from "../assets/Industry/Product.png"
import Icon3 from "../assets/Industry/Tracking.png"
import Icon4 from "../assets/Industry/Checklist.png"

import Navbar from "../components/Navbar";
const Warehouse = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 50) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [activeTab, setActiveTab] = useState("inventoryTracking");

  const content = {
    inventoryTracking: {
      title: "INVENTORY ACCURACY & STOCK VISIBILITY",
      description: [
        "Conduct regular stock checks with minimal manual effort.",
        "Monitor stock movement across zones and facilities.",
        "Enable seamless scanning and tracking for quick updates.",
      ],
      image: "warehouse_1.png",
    },
    spaceUtilization: {
      title: "EFFICIENT SPACE UTILIZATION & LAYOUT UTILIZATIONS",
      description: [
        "Identify Underutilized Areas and Rearrange Inventory for better flow.",
        "Adjust Product Placement based on demand trends and retrieval frequency.",
        "Detect congested zones and prevent bottlenecks in operations.",
      ],
      image: "warehouse_2.png", // Replace with your image URL or import it
    },
    improvedOperation: {
      title: "IMPROVING PICKING & PACKING OPERATIONS",
      description: [
        "Provide Real-Time Instructions for quick and accurate order picking.",
        "Identify Discrepancies before dispatch, reducing returns.",
        "Automate Sorting of high-priority orders for faster processing.",
      ],
      image: "warehouse_3.png",
    },
    safetyAnalytics: {
      title: "Safety Analytics",
      description: [
        "Monitor areas for unsafe practices, like blocked aisles or high-risk activities.",
        "Monitor Productivity and Forecast Demand for efficient replenishment.",
        "Ensure workers wear proper safety gear through Automated Monitoring.",
      ],
      image: "warehouse_4-2.png",
    },
  };

  return (
    <div>
      <Navbar />
      <div className="spacer"></div>

      <div className="container-mirrored">
        <div className="image-section-mirrored">
          <img src="123456.png" alt="Product Line" />
        </div>
        <div className="content-mirrored">
          <h1>
            Level up how you
            <br /> handle inventory{" "}
          </h1>
          <h4 style={{ fontWeight: "300" }}>
            With clear insights and smarter flow,you'll reduce errors, cut the
            clutter,and stay steps ahead.
            <br /> No more digginng through data—just visibility, control, and
            smooth operations.{" "}
          </h4>
          <Button
            onClick={()=>{navigate("/Demo")}}
            // href="https://forms.gle/P7B2NMVwGstAeVea8"
            className="know-more-btn"
          >
            Get Started
          </Button>
        </div>
      </div>

      <div className="centered-section">
        <h2>Watch Your Storage Make More Sense</h2>
        <h6>
          Let's turn that packed space into a smart one—with insights that help
          you organize better,move faster,and waste less.
        </h6>
        
      </div>

      <div className="app2">
        <div className="tabs2">
          {Object.keys(content).map((tabKey) => (
            <button
              key={tabKey}
              className={`tab2 ${activeTab === tabKey ? "active2" : ""}`}
              onClick={() => setActiveTab(tabKey)}
            >
              {content[tabKey].title.split(" & ")[0]}
            </button>
          ))}
        </div>

        <div className="content2">
          <div className="text-column2">
            <h2>{content[activeTab].title}</h2>
            <hr />
            <p>
              {content[activeTab].description.map((desc, index) => (
                <div key={index}>• {desc}</div>
              ))}
            </p>
          </div>
          <div className="image-column2">
            <img
              src={content[activeTab].image}
              alt={content[activeTab].title}
            />
          </div>
        </div>
      </div>

      <div className="app-container2">
        <header className="app-header2">
          <h1 className="title2">Our Story in Numbers</h1>
        </header>

        <div className="statistics-container2">
          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+30%</h2>
            <p className="statistic-description21">Inventory</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Through Automation</p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-50%</h2>
            <p className="statistic-description21">Defect Rate</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              With Quality Control System
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">+15%</h2>
            <p className="statistic-description21">
              Overall Equipment Effectiveness
            </p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">
              With Predictive Maintenance
            </p>
          </div>

          <div className="statistic-card2">
            <h2 className="statistic-percentage2">-30%</h2>
            <p className="statistic-description21">Lead Time Reduction</p>
            <div className="card-divider2"></div>
            <p className="statistic-description2">Through Streamline Process</p>
          </div>
        </div>
      </div>

      <div className="app-container3">
        <div className="content3" style={{ textAlign: "left" }}>
          <h1 className="title3">Maximize Warehouse Performance Using Argus</h1>
          <Button
            onClick={()=>{navigate('/contact')}}
            className="connect-button3"
          >
            Connect Now
          </Button>
        </div>

        <div className="card-container3">
          <div className="card3">
            <div className="icon3">
              <img src={Icon1} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Smart Space Utilization for optimal storage efficiency.​
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon2} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Inventory Transparency for precise control
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon3} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Automated Order Processing for faster, accurate picking.
            </h3>
          </div>

          <div className="card3">
            <div className="icon3">
              <img src={Icon4} style={{margin:"0", height:"70px"}} alt="Icon 1" />
            </div>
            <h3 className="card-title3">
              Dynamic Management for Real-Time Task allocation.
            </h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Warehouse;
